<template>
  <div class="m-wrap m-wap">
    <Banner :seminarInfo="seminarInfo" />

    <!--提交成功-->
    <SuccessCon
      :platform="platform"
      v-if="!signSuccess && (isRefuse == '0' || isRefuse == null)"
    />

    <!--审核未通过-->
    <RefuseCon
      :platform="platform"
      v-if="!signSuccess && isRefuse != '0' && isRefuse != null"
    />

    <!--报名成功-->
    <SuccessPartCon
      :platform="platform"
      :posterInfo="posterInfo"
      :category="category"
      v-if="signSuccess"
      @goInvite="goInvite"
    />

    <WapMeetEntry :seminarInfo="seminarInfo" v-if="!signSuccess" />
  </div>
</template>

<script>
import Banner from "@/components/BannerNew.vue";
import SuccessCon from "@/components/SuccessConNew.vue";
import SuccessPartCon from "@/components/SuccessPartConNew.vue";
import RefuseCon from "@/components/RefuseConNew.vue";
import WapMeetEntry from "@/components/WapMeetEntry.vue";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixinConfig from "../../mixin/configNew.js";
import mixinSuccess from "../../mixin/success.js";

export default {
  name: "WapSuccess",
  mixins: [mixinMeeting, mixinConfig, mixinSuccess],
  components: {
    Banner,
    SuccessCon,
    SuccessPartCon,
    RefuseCon,
    WapMeetEntry,
  },
  data() {
    return {
      platform: "wap",
      category: "",
    };
  },
};
</script>
